var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lastSuccessCartId > 0
    ? _c("share-outfit-modal", {
        attrs: {
          title: "Thank you for your purchase!",
          type: "cart",
          id: _vm.lastSuccessCartId
        },
        on: { close: _vm.closed }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56a06e3d", { render: render, staticRenderFns: staticRenderFns })
  }
}